import Dotdotdot from 'react-dotdotdot'
import { Grid, Stack } from '@mui/material'
import { muiTheme, type Nil, TextInteractive } from '@pbt/pbt-ui-components'

import { SendGearIcon as SystemMessageIcon } from '~/components/elements/Icons/generated'
import Typography from '~/components/elements/Typography/Typography'

import SystemMessageLabel from '../../common/SystemMessageLabel'

const MessageCardHeader = ({
  title,
  isLoading,
  isSystemMessage,
  sendingDateString,
}: {
  isLoading: boolean
  isSystemMessage: boolean | Nil
  sendingDateString: string
  title: string
}) => (
  <Grid container justifyContent="space-between">
    <Grid item alignItems="center" flexGrow={1}>
      <Grid container data-testId="message-card-from">
        <Grid item>
          <Dotdotdot clamp={1}>
            <TextInteractive strong isLoading={isLoading} variant="body2">
              {title}
            </TextInteractive>
          </Dotdotdot>
        </Grid>
        {!isLoading && isSystemMessage && (
          <Grid item ml={1}>
            <Stack direction="row" spacing={1}>
              <Typography.H3> | </Typography.H3>
              <SystemMessageLabel
                fontSize="H3"
                icon={
                  <SystemMessageIcon
                    sx={{ color: muiTheme.colors.grayGray1 }}
                  />
                }
              />
            </Stack>
          </Grid>
        )}
      </Grid>
    </Grid>
    <Grid item>
      <Dotdotdot clamp={1}>
        <TextInteractive isLoading={isLoading} variant="lowAccent2">
          {sendingDateString}
        </TextInteractive>
      </Dotdotdot>
    </Grid>
  </Grid>
)

export default MessageCardHeader
